import { jsx as _jsx } from "react/jsx-runtime";
import { TopNavigation } from '../top-navigation';
export function Header(param) {
    let { navigationItems } = param;
    return /*#__PURE__*/ _jsx("div", {
        "data-e2e": "LAYOUT_HEADER__HEADER",
        children: /*#__PURE__*/ _jsx(TopNavigation, {
            navigationItems: navigationItems
        })
    });
}
